import { useEffect } from "react";

/**
 * Pre-auth routes (login, signup, onboarding) use clinical-light tokens
 * so they match the main workspace white theme.
 * Cleans up on unmount so authenticated ThemeProvider can own html[data-theme].
 */
export function useClinicalShellTheme() {
  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-theme", "clinical-light");
    html.classList.remove("dark", "light");

    return () => {
      html.removeAttribute("data-theme");
    };
  }, []);
}

/** @deprecated alias — use useClinicalShellTheme */
export function useBrandShellTheme() {
  return useClinicalShellTheme();
}
